import React from "react";
import Link from "next/link";
import Image from "next/image";
import PropTypes from "prop-types";
import { mwImage } from "../../../lib/common";
import dayjs from "dayjs";
import { useTranslation } from "next-i18next";

const ProductUpdates = ({ productUpdates }) => {
  const { t } = useTranslation("common");
  const heroPost = productUpdates.slice(0, 1);
  const morePosts = productUpdates.slice(2, 5);

  return (
    <>
      <div className={"product-post"}>
        <div className={"container"}>
          <div className={"top-heading"}>
            <h2>Product Updates</h2>
            <Link
              href={"/product-updates/"}
              className={"read-more"}
            >
              {t('blog.viewAll')}
            </Link>
          </div>

          <div className={"d-flex"}>
            <div className={"left-block"}>
              {heroPost.map((productUpdate, index) => {
                return (
                  <div key={index}>
                    <Link href={`/product-updates/${productUpdate?.node?.slug}`} itemProp="url">
                      <Image
                        src={mwImage(productUpdate?.node?.featuredImage?.node?.sourceUrl)}
                        alt={productUpdate?.node?.title}
                        width={600}
                        height={400}
                        loading="lazy"
                        unoptimized
                        sizes="(max-width: 768px) 100vw, 600px"
                      />
                    </Link>
                    <Link
                      href={"/product-updates"}
                      itemProp="url"
                    >
                      <div
                        className={`category comparison`}
                      >
                        {t('productUpdates.category')}
                      </div>
                    </Link>
                    <Link href={`/product-updates/${productUpdate.node?.slug}/`} itemProp="url">
                      <h2>{productUpdate?.node?.title}</h2>
                    </Link>
                    <p>{productUpdate?.node?.subTitle?.subTitle}</p>
                    <div className={"date-time"}>
                      {dayjs(productUpdate?.node?.date).format("D MMM YYYY")}
                    </div>
                  </div>
                );
              })}
            </div>
            <div className={"right-block"}>
              {morePosts.map((morePosts, index) => {
                return (
                  <div key={index}>
                    <div className={"products"}>
                      <Link
                          href={"/product-updates"}
                          itemProp="url"
                      >
                        <div
                            className={`category comparison`}
                        >
                          {t('productUpdates.category')}
                        </div>
                      </Link>
                      <Link href={`/product-updates/${morePosts?.node?.slug}/`} itemProp="url">
                        <h4>{morePosts.node?.title}</h4>
                      </Link>
                      <div className={"date-time"}>
                        {dayjs(morePosts?.node?.date).format("D MMM YYYY")}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
ProductUpdates.defaultProps = {
  productUpdates: [],
};
ProductUpdates.propTypes = {
  productUpdates: PropTypes.array.isRequired,
};
export default ProductUpdates;
